// TODO: check if component property is necessary.

import React, { forwardRef, HTMLAttributes } from 'react'
import PropTypes from 'prop-types'

export const CMultiSelectSelectAllButton = forwardRef<
  HTMLButtonElement,
  HTMLAttributes<HTMLButtonElement>
>(({ children, ...rest }, ref) => {
  return (
    <button type="button" className="form-multi-select-all" {...rest} ref={ref}>
      {children}
    </button>
  )
})

CMultiSelectSelectAllButton.propTypes = {
  children: PropTypes.node,
}

CMultiSelectSelectAllButton.displayName = 'CMultiSelectSelectAllButton'
